module.exports = __webpack_public_path__ + "assets/img/two2.e43ce5d5.png";